import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { openUrl } from "@/utils/utils";
import { Card, Result } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate, useSearchParams } from "react-router";
import { useGetPartnerSsoAuthRedirectUrl } from "../../../common/api/queries";
import AntIcon from "../../../common/components/icons/AntIcon";
import { PARTNER_ROUTE_PATHS } from "../paths";

export const PartnerSsoOAuthRedirectContainer = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [urlParams] = useSearchParams();

  const { data, isError } = useGetPartnerSsoAuthRedirectUrl(
    {
      clientId: urlParams.get("client_id") ?? "",
      responseType: urlParams.get("response_type") ?? "",
      redirectUrl: urlParams.get("redirect_uri") ?? "",
      state: urlParams.get("state") ?? undefined,
      nonce: urlParams.get("nonce") ?? undefined,
      codeChallenge: urlParams.get("code_challenge") ?? undefined,
      codeChallengeMethod: urlParams.get("code_challenge_method") ?? undefined,
    },
    !!urlParams.get("client_id") && !!urlParams.get("response_type") && !!urlParams.get("redirect_uri"),
  );

  useEffect(() => {
    if (isError) {
      navigate(generatePath(PARTNER_ROUTE_PATHS.configs.to));
    }

    if (data) {
      openUrl(data);
    }
  }, [data, isError]);

  return (
    <ContentWrapper>
      <Card className="card-box" title={<h2>{t("partnerSso.titles.ssoPage")}</h2>}>
        <Result
          status="info"
          icon={<AntIcon type="loading" />}
          title={t("partnerSso.titles.automaticAuthentication")}
        />
      </Card>
    </ContentWrapper>
  );
};
